import { trace } from 'rytm-helpers'
import { gsap, TweenLite, TimelineMax, TweenMax, Elastic, Expo, Sine, Back, Power1, Power2, Power3, Power4 } from 'gsap'

// Back button
const onBackMouseEnter = (e) => {
  const svg = e.currentTarget.querySelector("svg")
  const line = e.currentTarget.querySelector("svg .line")
  
  if (line) {
    TweenMax.killTweensOf(line)
    TweenMax.killTweensOf(svg)
    let t = new TimelineMax({repeat: 0})
    t.to(line, .3, {drawSVG: "0% 0%", ease: Power4.easeIn})
    t.to(svg, .4, {x: 2, y: 3, rotationY: "180deg", ease: Power3.easeInOut})
    t.to(line, .4, {drawSVG: "0% 20%", ease: Power4.easeOut})
  }
}
const onBackMouseLeave = (e) => {
  const svg = e.currentTarget.querySelector("svg")
  const line = e.currentTarget.querySelector("svg .line")
  if (line) {
    TweenMax.killTweensOf(line)
    TweenMax.killTweensOf(svg)
    let t = new TimelineMax({repeat: 0})
    t.to(svg, .4, {x: 0, y: 0, rotationY: 0, ease: Power3.easeInOut})
    t.to(line, .3, {drawSVG: "0% 100%", ease: Power4.easeInOut})
  }
}



export const initHoverMorphs = () => {
  $('body').on('mouseenter', 'a.back-button', onBackMouseEnter);
  $('body').on('mouseleave', 'a.back-button', onBackMouseLeave);
}